<template>
    <div class="row">
        <div class="col-lg-12">
            <div v-if="loggedInUserRole === 'BRANCH' && isPortalEnabled">
                <PageTitle title="Orders -In Processing"
                           v-bind:crumbs="[{href:'/point_of_sale',title:'Home'},{href:'/orders',title:'orders'}]"/>
              <OrderNew></OrderNew>
            </div>
        </div>
    </div>
</template>

<script>
import PageTitle from "../components/layout_components/PageTitle";
import OrderNew from "../components/orders/branch/OrderNew";

export default {
    name: "BranchOrders",
    components: {
        PageTitle,
        OrderNew
    },
    data() {
        return {
            statusesWithoutUnAssignedOrder: [],
            isHideSpinner: ""
        }
    },
    created() {
        this.statusesWithoutUnAssignedOrder = [
            this.$status.ASSIGNED_TO_BRANCH.id,
            this.$status.ACCEPTED_BY_BRANCH.id,
            this.$status.READY_FOR_PICKUP.id,
            this.$status.CANCELED.id
        ]
    },     
    computed: {
        loggedInUserRole() {
            if (this.$store.state.user.fullName !== undefined && this.$store.state.user.userRolesById[0]) {
                return this.$store.state.user.userRolesById[0].role.split('_')[1]
            }
            return ""
        },
        isPortalEnabled() {
            return (this.$store.state.user.branch && this.$store.state.user.branch.isPortalEnabled)
        },
    },
    methods: {
    }
}
</script>

<style scoped>
.margin-horizontal-15 {
    margin-left: -15px !important;
    margin-right: -15px !important;
}
</style>
